import { queryOptions } from "@tanstack/react-query";
import api from "~/shared/api/core/api";
import { SearchResponse, UnreadCountResponse } from "~/shared/api/dashboard/dashboard.types";
import { Params } from "~/shared/api/types/params";

export const DASHBOARD_KEYS = {
  all: "dashboard" as const,
  search: (params: Params) => [DASHBOARD_KEYS.all, "search", params] as const,
  unreadCount: () => [DASHBOARD_KEYS.all, "unreadCount"] as const,
};

export const DASHBOARD_QUERIES = {
  search: (params: Params) => {
    return queryOptions({
      queryKey: DASHBOARD_KEYS.search(params),
      queryFn: async ({ signal }) => {
        const response = await api.get<SearchResponse>(`/dashboard/search`, {
          signal,
          ...params,
        });

        return response.data;
      },
    });
  },
  unreadCount: () => {
    return queryOptions({
      queryKey: DASHBOARD_KEYS.unreadCount(),
      queryFn: async ({ signal }) => {
        const response = await api.get<UnreadCountResponse>(`/dashboard/unread-count`, {
          signal,
        });

        return response.data;
      },
    });
  },
};
